import React, { Component } from 'react';
import couterpart from 'counterpart';
import { TiArrowBackOutline } from 'react-icons/ti';
import { FaRegSave } from 'react-icons/fa';
import { ToastsContainer, ToastsStore } from 'react-toasts';

import MenuComponent2 from './MenuComponent2';
import ItemDataService from '../services/ItemDataService';
import UploaderItemImage from './UploaderItemImage';
import ItemImageViewer from './ItemImageViewer';
// import UserDataService from '../services/UserDataService';

import '../css/style.css';
import { ICON_COLOR } from '../icon';
import AuthenticationService from '../services/AuthenticationService';

class ItemDetailsEdit extends Component {
    constructor() {
        super();
        this.state = {
            id: 0,
            name: '',
            sku: '',
            semi: 0,
            itemType: 0,
            colorMaterial: '',
            shapeDesign: '',
            lengthSize: '',
            otherSubOptions: '',
            updated: null,
            msg: '',
            images: [],
            assignedTo: '',
            selectOptions: [],
            nhom: '',
            nhomEn: '',
            tenVthh: '',
            dhlDescription: '',
            priority: 0,
            hsCode: '',
            giaXk: '',
            kl: '',
            dhlMasters: [],
            dhlMaster: {},
        }
    };

    loadDhlMasters() {
        ItemDataService.retrieveDHLMasters().then(data => {
        if (data.message === undefined) {
            this.setState({ dhlMasters: data })
        } else {
            this.setState({ dhlMasters: [] })
        }
        });
    }

    componentDidMount() {
        this.loadDhlMasters();

        const { id } = this.props.match.params;
        if ((id === undefined) || (id === null)) {
            return;
        }

        ItemDataService.retrieveById(`${id}`).then(data => {
            console.log('retrieveById', data)
            this.setState({
                id: id,
                name: data.name,
                sku: data.sku,
                category: data.category,
                colorMaterial: data.colorMaterial,
                shapeDesign: data.shapeDesign,
                lengthSize: data.lengthSize,
                otherSubOptions: data.otherSubOptions,
                description: data.description,
                dhlDescription: data.dhlDescription,
                hsCode: data.hsCode,
                giaXk: data.giaXk,
                kl: data.kl,
                priority: data.priority,
                shop: data.shop,
                assignedTo: data.assignedTo,
                semi: data.semi,
                itemType: data.itemType,
                msg: ''
            }, () => {
                ItemDataService.retrieveImagesOfItem(this.state.id).then(data => {
                    this.setState({ images: data });
                });
            })
        });
    }

    handleChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]: value });
    }

    handleSemiChange(e) {
        if (this.state.semi === 1) {
            this.setState({ semi: 0 });
        } else {
            this.setState({ semi: 1 });
        }
    }

    handleItemTypeChange(value) {
        console.log(value);
        this.setState({ itemType: value });
    }

    handleSave() {
        var msg = "";
        if ((this.state.sku === undefined) ||
            (this.state.sku === null) ||
            (this.state.sku.length < 1)) {
            const msg_item_sku_missing = couterpart.translate('msg_item_sku_missing');
            ToastsStore.error(msg_item_sku_missing);
            return;
        }

        if ((this.state.dhlDescription === undefined) ||
            (this.state.dhlDescription === null) ||
            (this.state.dhlDescription.length < 1)) {
            const msg_item_dhlDescription_missing = couterpart.translate('msg_item_dhlDescription_missing');
            ToastsStore.error(msg_item_dhlDescription_missing);
            return;
        }

        try {
            if ((this.state.id != null) && (this.state.id > 0)) {
                ItemDataService.update(this.state).then(data => {
                    if (data.id !== undefined && data.id > 0) {
                        msg = couterpart.translate("msg_item_update_ok");
                        this.setState({ msg: msg });
                    } else {
                        if (data.id === -1) {
                            alert("Không thể cập nhật item. SKU mới Đã tồn tại trong hệ thống");
                        } else {
                            alert("Không thể cập nhật item: " + data);
                        }
                    }
                });
            } else {
                ItemDataService.save(this.state).then(data => {
                    if (data.id !== undefined && data.id > 0) {
                        msg = couterpart.translate("msg_item_update_ok");
                        this.setState({ id: data.id, msg: msg }, () => {
                            ItemDataService.retrieveImagesOfItem(this.state.id).then(data => {
                                this.setState({ images: data });
                            });
                        });
                    } else {
                        if (data.id === -1) {
                            alert("Không thể tạo item mới. SKU mới Đã tồn tại trong hệ thống");
                        } else {
                            alert("Không thể tạo item mới.");
                        }
                    }
                });
            }
        } catch (e) {
            alert(e.message)
        }
    }

    handleUpdate() {
        ItemDataService.retrieveImagesOfItem(this.state.id).then(data => {
            this.setState({ images: data, updated: true });
        });
    }

    backToList() {
        this.props.history.push("/items");
    }

    handleSelectChange(e) {
        var value = e.target.value;
        this.setState({ assignedTo: value });
    }

    renderOption(option) {
        return (
            <option key={option.value} value={option.value}>{option.label}</option>
        );
    }

    renderUserSelection() {
        let options = this.state.selectOptions !== undefined ? this.state.selectOptions : []
        console.log('renderUserSelection', options)
        return (
            <select className="selectBox3" value={this.state.assignedTo}
                onChange={this.handleSelectChange.bind(this)}>
                <option key="empty" value=""></option>
                {options.map(option => this.renderOption(option))}
            </select>
        );
    }

    renderAllShopList() {
        if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()) {
            return (<>&nbsp;</>);
        }
        let options = this.state.dhlMasters !== undefined ? this.state.dhlMasters : []
        return (
            <select className="selectBox4" value={this.state.dhlDescription} onChange={this.handleSelectChange.bind(this)} name="dhlDescription" style={{ width: '100%'}}>
                <option key="empty" value=""></option>
                {options.map(option => this.renderAllShopOption(option))}
            </select>
        );
    }

    handleSelectChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        var dhlMaster = this.getDhlMasterBy(value);
        console.log(dhlMaster);
        this.setState({ 
            [name]: value,
            dhlMaster: dhlMaster
        });
        
    }

    renderAllShopOption(option) {
        return (
            <option key={option.id} value={option.dhlDescription}>{option.dhlDescription}</option>
        );
    }

    getDhlMasterBy(dhlDescription){
        let x = this.state.dhlMasters.filter(it => {
            return it.dhlDescription === dhlDescription;
        });
        if (x !== undefined && x !== null && x.length > 0){
            return x[0];
        }
        return {};
    }

    render() {
        return (
            <div>
                <MenuComponent2 />
                <div style={{ padding: "5px" }}>
                    <button className="myButton" onClick={this.backToList.bind(this)}>
                        <TiArrowBackOutline color={ICON_COLOR} />&nbsp;
                        {couterpart.translate('button_back')}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <div>
                    <br />
                    <table width="90%" border="0" align="center">
                        <tbody>
                            <tr>
                                <td><label>*{couterpart.translate('item_sku')}</label></td>
                                <td><input name="sku" type="text"
                                    placeholder="" defaultValue={this.state.sku}
                                    onChange={this.handleChange.bind(this)} /></td>
                            </tr>
                            <tr>
                                <td><label>*{couterpart.translate('item_details_dhlDescription')}</label></td>
                                <td>{ this.renderAllShopList() }</td>
                            </tr>
                            <tr>
                                <td><label>*{couterpart.translate('item_details_priority')}</label></td>
                                <td><label>{this.state.dhlMaster.priority} </label></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_details_hsCode')}</label></td>
                                <td><label>{this.state.dhlMaster.hsCode} </label></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_details_giaXk')}</label></td>
                                <td><label>{this.state.dhlMaster.giaXk} </label></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_details_kl')}</label></td>
                                <td><label>{this.state.dhlMaster.kl} </label></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_design')}</label></td>
                                <td><input name="shapeDesign" type="text"
                                    placeholder="" defaultValue={this.state.shapeDesign}
                                    onChange={this.handleChange.bind(this)} /></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_price')}</label></td>
                                <td><input name="price" type="text"
                                    placeholder="" defaultValue={this.state.price}
                                    onChange={this.handleChange.bind(this)} /></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_semi')}</label></td>
                                <td><input type="checkbox" value={1} checked={this.state.semi === 1 ? true : false} onChange={this.handleSemiChange.bind(this)} /></td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_type')}</label></td>
                                <td>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 0 ? true : false} onChange={this.handleItemTypeChange.bind(this, 0)} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_normal')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 1 ? true : false} onChange={this.handleItemTypeChange.bind(this, 1)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_len')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 2 ? true : false} onChange={this.handleItemTypeChange.bind(this, 2)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_lenda')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 5 ? true : false} onChange={this.handleItemTypeChange.bind(this, 5)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_leninox')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 3 ? true : false} onChange={this.handleItemTypeChange.bind(this, 3)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_da')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 4 ? true : false} onChange={this.handleItemTypeChange.bind(this, 4)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_dainox')}</label></td>

                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 6 ? true : false} onChange={this.handleItemTypeChange.bind(this, 6)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_lenbac')}</label></td>
                                            <td><input type="checkbox" value={1} checked={this.state.itemType === 7 ? true : false} onChange={this.handleItemTypeChange.bind(this, 7)} style={{ marginLeft: "20px" }} /></td>
                                            <td><label style={{ marginBottom: "0" }}>{couterpart.translate('item_dabac')}</label></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td><label>{couterpart.translate('item_description')}</label></td>
                                <td><input name="description" type="text"
                                    placeholder="" defaultValue={this.state.description}
                                    onChange={this.handleChange.bind(this)} /></td>
                            </tr>
                            <tr>
                                <td><button className="myButton"
                                    onClick={this.handleSave.bind(this)}>
                                    <FaRegSave color={ICON_COLOR} />&nbsp;
                                    {couterpart.translate('button_save')}</button></td>
                                <td>{this.state.msg}</td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <UploaderItemImage
                                        caption={couterpart.translate('item_upload_title')}
                                        handleUpdate={this.handleUpdate.bind(this)}
                                        itemId={this.state.id} />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <ItemImageViewer caption={couterpart.translate('item_upload_title')} mode="MODE_EDIT"
                                        images={this.state.images}
                                        isUpdated={this.state.updated}
                                        handleUpdate={this.handleUpdate.bind(this)} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
            </div>
        );
    }
}

export default ItemDetailsEdit;